import React, { Component } from "react";

export default class RAship extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container">
          Visit this link and scroll down to 3) RESEARCH ASSISTANTSHIPS to apply for RA ship - &nbsp;&nbsp;
          <a href="https://cs.uga.edu/graduate-financial-assistance" target={"_blank"} rel={"noreferrer"}>
            RA ship
          </a>
          <div>
            Research Assistanceship depends on the professor. If you like the a research a professor is working on, then you can reach out
            to them and prove your interest.
            <p>You need to have a resume and also show your interest.</p>
            <p>
              Check this question out - In order to apply for Computer Science RA ship, please provide a one page letter (PDF) giving
              qualifications and interest and indicate the term of interest.{" "}
            </p>
          </div>
          The key here is to reach out to the professors that are working on projects you are interested in.
        </div>
      </React.Fragment>
    );
  }
}
